export default __webpack_public_path__ + "static/media/Background_00092.2ebc4359.png";